import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      const diff = tomorrow.getTime() - now.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleCheckout = () => {
    window.location.href = 'http://checkout.sectordigital.online/cart/44174195425323:1';
  };
  const includes = ['Todo el KIT Psicología en Gerontes', 'BONUS: Guía de Psicoeducación para Familias de Gerontes', 'BONUS: Plantilla de Evaluación Inicial del Geronte', 'BONUS: Guía de Actividades Terapéuticas para Gerontes'];
  return <section id="comprar" className="w-full py-10 md:py-20 bg-[#faf9f7]" data-id="element-73">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <h2 className="text-2xl md:text-4xl font-bold text-[#14505c] mb-1 text-center" data-id="element-76">
            ESTRUCTURÁ EL PROCESO TERAPÉUTICO CON GERONTES
          </h2>
          <p className="text-base md:text-xl text-gray-600 mb-6 md:mb-8 text-center" data-id="element-77">
            Un solo pago. Tuyo para siempre.
          </p>

          <div className="bg-white p-5 md:p-8 rounded-2xl shadow-2xl border-2 border-[#d97706]" data-id="element-78">
            <div id="oferta-reloj" className="bg-gradient-to-br from-red-600 to-red-700 rounded-xl p-4 md:p-5 mb-5 shadow-lg scroll-mt-24" data-id="element-79">
              <div className="flex items-center justify-center gap-2 text-white mb-2" data-id="element-80">
                <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-81" />
                <span className="font-bold uppercase tracking-wide text-xs md:text-sm" data-id="element-82">
                  La oferta termina en:
                </span>
              </div>
              <div className="flex items-center justify-center gap-1.5 md:gap-3" data-id="element-83">
                {[{
                value: timeLeft.hours,
                label: 'Horas'
              }, {
                value: timeLeft.minutes,
                label: 'Min'
              }, {
                value: timeLeft.seconds,
                label: 'Seg'
              }].map((unit, idx) => <Fragment key={unit.label} data-id="element-84">
                    <div className="flex flex-col items-center" data-id="element-85">
                      <span className="bg-white text-red-600 rounded-lg px-2.5 py-1.5 md:px-3 md:py-2 text-xl md:text-4xl font-bold tabular-nums shadow-md min-w-[2.5rem] md:min-w-[3rem] text-center" data-id="element-86">
                        {String(unit.value).padStart(2, '0')}
                      </span>
                      <span className="text-white/90 text-[9px] md:text-xs font-semibold mt-1 uppercase tracking-wide" data-id="element-87">
                        {unit.label}
                      </span>
                    </div>
                    {idx < 2 && <span className="text-white text-xl md:text-3xl font-bold pb-4 md:pb-5" data-id="element-88">
                        :
                      </span>}
                  </Fragment>)}
              </div>
            </div>

            <h3 className="text-xl md:text-2xl font-bold text-[#14505c] mb-1 text-center" data-id="element-89">
              KIT Psicología en Gerontes
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-5 text-center" data-id="element-90">
              Sistema práctico para conducir el proceso terapéutico con gerontes
              desde el primer día.
            </p>

            <div className="flex flex-col items-center mb-5" data-id="element-91">
              <span className="text-lg md:text-2xl text-gray-400 line-through mb-1" data-id="element-92">
                $49.990
              </span>
              <div className="flex items-center gap-3" data-id="element-93">
                <span className="text-4xl md:text-5xl font-bold text-[#14505c]" data-id="element-94">
                  $19.990
                </span>
                <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-1 rounded-full" data-id="element-95">
                  -60%
                </span>
              </div>
            </div>

            <div className="bg-[#faf9f7] rounded-xl p-4 mb-5" data-id="element-96">
              <p className="font-semibold text-gray-700 mb-3 text-sm md:text-base" data-id="element-97">
                Incluye:
              </p>
              <ul className="space-y-2" data-id="element-98">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-99">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-100" />
                    <span className="text-gray-700 text-sm md:text-base" data-id="element-101">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <button onClick={handleCheckout} className="bg-[#d97706] hover:bg-[#b45309] text-white font-bold text-lg md:text-xl px-8 py-4 md:py-5 rounded-xl transition-colors duration-200 shadow-lg hover:shadow-xl w-full mb-4" data-id="element-102">
              SÍ, QUIERO EL KIT AHORA
            </button>

            <p className="text-center text-xs md:text-sm text-gray-500" data-id="element-103">
              Pago único · Acceso inmediato · Garantía 7 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}